import { createContext } from 'react';
import type { PremiumStatus } from '../types';

export type PremiumContextType = PremiumStatus;

export const PremiumContext = createContext<PremiumContextType | undefined>(undefined);
